<div class="container">
  <mat-card>
    <mat-card-title>Action Logs</mat-card-title>
    <mat-card-content>
      <table mat-table [dataSource]="data" class="mat-elevation-z8">
        <!-- Timestamp Column -->
        <ng-container matColumnDef="created_at">
          <th mat-header-cell *matHeaderCellDef>
            <div class="column-header">
              <span>Timestamp</span>
            </div>
          </th>
          <td mat-cell *matCellDef="let log">{{ log.created_at | date:'short' }}</td>
        </ng-container>

        <!-- User Column -->
        <ng-container matColumnDef="username">
          <th mat-header-cell *matHeaderCellDef>
            <div class="column-header">
              <span>User</span>
            </div>
          </th>
          <td mat-cell *matCellDef="let log">{{ log.username }}</td>
        </ng-container>

        <!-- Church Column -->
        <ng-container matColumnDef="church_id">
          <th mat-header-cell *matHeaderCellDef>
            <div class="column-header">
              <span>Church</span>
            </div>
          </th>
          <td mat-cell *matCellDef="let log">{{ log.church_id }}</td>
        </ng-container>

        <!-- Topic Column -->
        <ng-container matColumnDef="topic">
          <th mat-header-cell *matHeaderCellDef>
            <div class="column-header">
              <span>Type</span>
            </div>
          </th>
          <td mat-cell *matCellDef="let log">{{ log.topic }}</td>
        </ng-container>

        <!-- Message Column -->
        <ng-container matColumnDef="message">
          <th mat-header-cell *matHeaderCellDef>
            <div class="column-header">
              <span>Message</span>
            </div>
          </th>
          <td mat-cell *matCellDef="let log">{{ log.message }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator
        [length]="totalLogs"
        [pageSize]="pageSize"
        [pageSizeOptions]="[5, 10, 20]"
        (page)="onPageChange($event)">
      </mat-paginator>
    </mat-card-content>
  </mat-card>
</div>
